document.addEventListener("DOMContentLoaded", function () {

  const countdowns = document.querySelectorAll("[data-countdown]");

  countdowns.forEach(function(countdown) {

    let endDate = countdown.dataset.end;

    if (!endDate) return;

    endDate = endDate.replace(/([+-]\d{2})(\d{2})$/, "$1:$2");

    const end = new Date(endDate).getTime();

    const daysEl = countdown.querySelector(".days");
    const hoursEl = countdown.querySelector(".hours");
    const minutesEl = countdown.querySelector(".minutes");
    const secondsEl = countdown.querySelector(".seconds");

    function updateCountdown() {

      const now = new Date().getTime();

      const distance = end - now;

      if (distance <= 0) {
        countdown.style.display = "none";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));

      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) /
        (1000 * 60 * 60)
      );

      const minutes = Math.floor(
        (distance % (1000 * 60 * 60)) /
        (1000 * 60)
      );

      const seconds = Math.floor(
        (distance % (1000 * 60)) / 1000
      );

      daysEl.innerText = String(days).padStart(2, "0");
      hoursEl.innerText = String(hours).padStart(2, "0");
      minutesEl.innerText = String(minutes).padStart(2, "0");
      secondsEl.innerText = String(seconds).padStart(2, "0");
    }

    updateCountdown();

    setInterval(updateCountdown, 1000);

  });

});
